export const groupMembershipActions = Object.freeze({
  JOIN: 'join',
  LEAVE: 'leave',
});
